import disqualificationApplicationReducer from "./disqualificationApplicationReducer";

const disqualificationApplicationReducers = {
    disqualificationApplication: disqualificationApplicationReducer,
};

export default disqualificationApplicationReducers;